import { render, staticRenderFns } from "./tit-secondary.vue?vue&type=template&id=b705f63e&scoped=true&"
import script from "./tit-secondary.vue?vue&type=script&lang=js&"
export * from "./tit-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b705f63e",
  null
  
)

export default component.exports